import { getActiveAccountId } from '#pplx/frontend/browser-storage/activeAccount.js';
const ROUTE_HEADER = 'X-Connector-Service-Route';
const CONNECTOR_PATH = /^\/rest\/(?:connector-service|connectors|connections|pipedream|sources)(?:\/|$)/;
let selectedUser;
// The feature provider owns identity and SDK readiness. Registering its selector
// here keeps the low-level fetcher independent of the experimentation package.
export function registerConnectorGoProxySelector(selector) {
    selectedUser = selector;
    return () => {
        if (selectedUser === selector)
            selectedUser = undefined;
    };
}
export function applyConnectorGoProxyRoute(url, currentOrigin, headers) {
    headers.delete(ROUTE_HEADER);
    if (url.origin !== currentOrigin || !CONNECTOR_PATH.test(url.pathname))
        return;
    const userId = selectedUser?.();
    if (!userId)
        return;
    const requestAccount = headers.get('X-Pplx-Account') || getActiveAccountId();
    if (requestAccount && requestAccount !== userId)
        return;
    headers.set(ROUTE_HEADER, 'go');
}
//# sourceMappingURL=connectorRouting.js.map